/* PLGRIM — theme.js
   Vanilla, no dependencies. Drawers, cart, rails, hotspots, announcement rotator. */
(function () {
  'use strict';

  var R = (window.PLGRIM && window.PLGRIM.routes) || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = (window.PLGRIM && window.PLGRIM.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = parts[0];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var focusable = d.querySelector('input, button, a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 260);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function closeAllDrawers() { $$('.drawer.is-open').forEach(closeDrawer); }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }
    var cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen) {
      e.preventDefault();
      if ((window.PLGRIM && window.PLGRIM.cartType) === 'page') { window.location.href = R.cart_url; return; }
      refreshCart().then(function () { openDrawer('CartDrawer'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllDrawers(); });

  /* ---------- announcement rotator ---------- */
  (function announcementBar() {
    var bar = $('[data-abar]');
    if (!bar) return;
    var msgs = $$('.abar__msg', bar);
    if (msgs.length < 2) { var t = $('[data-abar-toggle]', bar); if (t) t.style.display = 'none'; return; }
    var i = 0, playing = true, timer;
    var speed = 5000;
    function step() {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    function start() { timer = setInterval(step, speed); }
    start();
    var toggle = $('[data-abar-toggle]', bar);
    if (toggle) {
      toggle.addEventListener('click', function () {
        playing = !playing;
        if (playing) { start(); toggle.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor"><rect x="7" y="5" width="3.4" height="14"></rect><rect x="13.6" y="5" width="3.4" height="14"></rect></svg>'; }
        else { clearInterval(timer); toggle.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor"><path d="M7 5l12 7-12 7V5Z"></path></svg>'; }
        toggle.setAttribute('aria-label', playing ? 'Pause announcements' : 'Play announcements');
      });
    }
  })();

  /* ---------- header nav overflow arrow ---------- */
  (function navScroll() {
    var scroller = $('[data-nav-scroll]');
    var next = $('[data-nav-next]');
    if (!scroller || !next) return;
    function sync() {
      var overflowing = scroller.scrollWidth > scroller.clientWidth + 4;
      next.style.display = overflowing ? 'flex' : 'none';
    }
    next.addEventListener('click', function () { scroller.scrollBy({ left: 240, behavior: 'smooth' }); });
    window.addEventListener('resize', sync);
    sync();
  })();

  /* ---------- carousel rails ---------- */
  function initRail(rail) {
    var track = $('[data-rail-track]', rail);
    if (!track) return;
    var prev = $('[data-rail-prev]', rail);
    var next = $('[data-rail-next]', rail);
    function page() { return Math.max(track.clientWidth * 0.8, 260); }
    function sync() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  $$('[data-rail]').forEach(initRail);

  /* ---------- hotspots ---------- */
  $$('[data-setup]').forEach(function (setup) {
    var spots = $$('[data-hotspot]', setup);
    var panel = $('[data-setup-panel]', setup);
    if (!spots.length || !panel) return;
    function show(spot) {
      spots.forEach(function (s) { s.classList.remove('is-active'); });
      spot.classList.add('is-active');
      panel.innerHTML = spot.getAttribute('data-card') || '';
    }
    spots.forEach(function (spot) {
      spot.addEventListener('mouseenter', function () { show(spot); });
      spot.addEventListener('focus', function () { show(spot); });
      spot.addEventListener('click', function (e) { e.preventDefault(); show(spot); });
    });
    show(spots[0]);
  });

  /* ---------- cart ---------- */
  function getSectionHtml(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.text(); });
  }

  function refreshCart() {
    return fetch(R.cart_url + '?view=drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('[data-cart-body]');
        var foot = doc.querySelector('[data-cart-foot]');
        var count = doc.querySelector('[data-cart-count]');
        if (body) { var target = $('[data-cart-body]'); if (target) target.innerHTML = body.innerHTML; }
        if (foot) { var ft = $('[data-cart-foot]'); if (ft) ft.innerHTML = foot.innerHTML; }
        if (count) {
          $$('[data-cart-count]').forEach(function (el) { el.textContent = count.textContent; });
          $$('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + count.textContent.trim() + ')'; });
        }
      })
      .catch(function () {});
  }

  function addToCart(formData, button) {
    if (button) { button.setAttribute('aria-disabled', 'true'); button.dataset.label = button.textContent; button.textContent = '…'; }
    return fetch(R.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || res.body.message || 'Could not add'); return; }
        return refreshCart().then(function () {
          if ((window.PLGRIM && window.PLGRIM.cartType) === 'page') { window.location.href = R.cart_url; return; }
          openDrawer('CartDrawer');
          toast(window.PLGRIM.strings.addedToCart);
        });
      })
      .catch(function () { toast('Network error'); })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); if (button.dataset.label) button.textContent = button.dataset.label; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add], form.product-form');
    if (!form) return;
    e.preventDefault();
    addToCart(new FormData(form), form.querySelector('button[type="submit"]'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    var line = btn.getAttribute('data-line');
    var qty = btn.getAttribute('data-qty');
    fetch(R.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function () {
      refreshCart();
      if (document.body.classList.contains('template--cart')) window.location.reload();
    });
  });

  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(R.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  });

  /* ---------- product variants ---------- */
  $$('[data-variant-picker]').forEach(function (picker) {
    var form = document.getElementById(picker.getAttribute('data-form'));
    var dataEl = $('[data-variant-json]', picker);
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = $('[data-pdp-price]');
    var addBtn = form.querySelector('[data-add-btn]');
    var skuEl = $('[data-pdp-sku]');

    function selected() {
      return $$('.pdp__swatch input:checked', picker).map(function (i) { return i.value; });
    }

    function update() {
      var chosen = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      $$('.pdp__swatch', picker).forEach(function (l) {
        var input = l.querySelector('input');
        l.classList.toggle('is-active', input && input.checked);
      });

      if (!match) {
        if (addBtn) { addBtn.textContent = window.PLGRIM.strings.unavailable; addBtn.setAttribute('aria-disabled', 'true'); }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? '<del>' + formatMoney(match.compare_at_price) + '</del><ins>' + formatMoney(match.price) + '</ins>'
          : formatMoney(match.price);
      }
      if (skuEl) skuEl.textContent = match.sku || '—';
      if (addBtn) {
        if (match.available) { addBtn.textContent = window.PLGRIM.strings.addToCart; addBtn.removeAttribute('aria-disabled'); }
        else { addBtn.textContent = window.PLGRIM.strings.soldOut; addBtn.setAttribute('aria-disabled', 'true'); }
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
      var media = document.querySelector('[data-media-id="' + (match.featured_media ? match.featured_media.id : '') + '"]');
      if (media) media.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    picker.addEventListener('change', update);
    update();
  });

  /* ---------- quantity steppers on PDP ---------- */
  $$('[data-qty-stepper]').forEach(function (wrap) {
    var input = $('input', wrap);
    $$('button', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var delta = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = v;
      });
    });
  });

  /* ---------- predictive search ---------- */
  (function predictive() {
    var input = $('[data-predictive-input]');
    if (!input) return;
    var results = $('[data-predictive-results]');
    var fallback = $('[data-predictive-default]');
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; if (fallback) fallback.style.display = ''; return; }
      t = setTimeout(function () {
        fetch(R.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
            if (fallback) fallback.style.display = 'none';
          })
          .catch(function () {});
      }, 240);
    });
  })();


  /* ---------- product recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          initRail(el);
        }
      })
      .catch(function () {});
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- facet auto-submit ---------- */
  $$('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form));
      window.location.search = params.toString();
    });
  });
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-facet-toggle]');
    if (btn) {
      var pop = btn.parentElement.querySelector('.facet__pop');
      var isOpen = pop.style.display === 'block';
      $$('.facet__pop').forEach(function (p) { p.style.display = 'none'; });
      pop.style.display = isOpen ? 'none' : 'block';
      return;
    }
    if (!e.target.closest('.facet')) $$('.facet__pop').forEach(function (p) { p.style.display = 'none'; });
  });

  /* ---------- shopify section re-init (theme editor) ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-rail]', e.target).forEach(initRail);
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });

  window.PLGRIM.refreshCart = refreshCart;
  window.PLGRIM.toast = toast;
})();
